import React from 'react';
import SEO from '@/SEO';

const HTML_CONTENT = `<h1>ஔபாஸனம்</h1>
<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
01-முன்னுரை
    </mat-expansion-panel-header>
    <div class="div3">
      ஔபாஸனம் என்பது ஒரு நித்யகர்மா. ஒவ்வொரு க்ருஹஸ்தனும் 
      காலை - மாலை இருவேளையும் தவறாமல் செய்யவேண்டியதாகும். 
      தம்பதிகள் - தங்கள் விவாஹத்தில் மாலையில் ஆரம்பிக்கப்பட்ட ஔபாஸன 
      அக்னியை - இருவரில் எவர் முன்னதாக திருநாடு அலங்கரிக்கிறாரோ - அதுவரை 
      காலை - மாலை இருவேளையும் ஔபாஸனம் செய்து அக்னியை ரக்ஷித்த வரவேண்டும் 
      என்பது சாஸ்த்ரம் ஆகும்<hr class="orange">
      யாது காரணம்பற்றி ஔபாஸனம் சில தினங்கள் தொடர்ந்து 
      செய்யமுடியாமற்போனல், அதற்கு விச்சித்தி தோஷம் ஏற்படும். 
      அப்படிப்பட்ட சூழலில் “அக்னி ஸந்தானம்” என்னும் தலைப்பில் 
      கண்டுள்ளவாறு, அக்னிஸந்தானம் செய்து தொடர்ந்து ஔபாஸன 
      க்ருச்ரங்களையும், தண்டுலதானத்தையும் செய்துவிட்டு பின்னர் 
      ஔபாஸனம் செய்யவேண்டும். <hr class="orange">
      தொடர்ந்து ஔபாஸனம் செய்து வருகிறவர்களுக்கு இந்த உதவி 
      தேவையிருக்கப்பபோவதில்லை. மற்றவர்கள் அறிந்துகொள்ள இதை 
      இங்கே விளக்கவேண்டியதாயிற்று. 
       <hr class='orange'>
       ஒரு நாள் அக்னிஸந்தானம் செய்து ஔபாஸனம் செய்த அக்னியை 
       அணையாமல் பாதுகாத்து வந்தால், அந்த அக்னியும் அணையாமல், 
       ஔபாஸனமும் தவறாமல் தொடர்ந்து செய்கிறவரை மீண்டும் 
       அக்னிஸந்தானம் செய்யத் தேவையில்லை. <br>
       ஔபாஸனத்திற்கான அநுஜ்ஞை மட்டும் செய்துகொண்டு 
       க்ருச்ர, தானாதிகளையும் தவிர்த்து நேராக ஔபாஸனம் செய்யலாம். <br>
       அடுத்தவேளை ஔபாஸனம் தொடர இயலாது என்பதை அறிந்திருந்தால் 
       தவறாமல் ஔபாஸனம் முடிந்தவுடனோ, அக்னி அணைவதற்கு முன்னரோ,
       அக்னியை ஆத்மஸமாரோபணம் செய்துகொள்ளவேண்டும். 
      
    </div>
  </mat-expansion-panel>
<mat-expansion-panel>
    <mat-expansion-panel-header>
      02-அநுஜ்ஞை
    </mat-expansion-panel-header>
    <div class="div3">
      பவித்ரம் த்ருத்வா! பத்ந்யாஸ: தாம்பூல தக்ஷிண அக்ஷதாநு க்ருஹீத்வா! ஹரி: ஓம் நமஸ்ஸதஸே நமஸ்ஸதஸ: பதயே நம: ஸகீநாம் ப்ரோகாணாம் க்ஷக்ஷுஸே நமோதிவே நம:ப்ருத்வ்யை ஸப்ரதா ஸபாம்மே கோபாயா யேசஸப்யா: ஸபாஸத: தாநு இந்திரியாவத: குரு ஸர்வமாயு: உபாஸதாம் ஸர்வேப்ய: ஸ்ரீவைஷ்ணவேப்யோ நம: 
      இதி ப்ராஹ்மணாநு அப்யர்ச்சயா! நமஸ்க்ருத்யா!
தக்ஷிணாம் தாம்பூலஞ்ச க்ருஹீத்வா! ஸ்வாமிந: பவத்பாதமூலே மயா ஸமர்ப்பிதாம் இமாம் சௌவர்ணீம் தக்ஷிணாம் யத்கிஞ்சிது தக்ஷிணாம் யதோக்த தக்ஷிணாமிவ ஸ்வீக்ருத்யா! ஆவயோ: 
<span class="hint"> காலையில் </span> ப்ராத:/
<span class="hint"> மாலையில் </span> ஸாயம்
  ஒளபாஸன கர்ம கர்த்தும் யோக்யதா ஸித்திம் அநுக்ரஹாணா!
    </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
  <mat-expansion-panel-header>03- ஒளபாஸன க்ருச்ரம்
  </mat-expansion-panel-header><div class="div3">
    ப்ராணாநாயம்யா! ஸ்ரீ-ம். ஆவயோ: ஒளபாஸந விச்சேத ப்ரப்ருதி ஏதத்க்ஷண பர்யந்தம் ஒளபாஸந த்ரவ்ய ஸ்தாலீபாக த்ரவ்ய க்ருச்ர த்ரவ்ய ஆஜ்ய த்ரவ்ய ப்ரதிநிதி யத்க்கிஞ்சிது ஹிரண்ய ஸஹித தண்டுல தாநம் கரிஷ்யே!
    தண்டுலா: வைஸ்வதேவத்யா: பாகேந அந்நம் பசந்தியே தஸ்மாது தண்டுல தாநேநா அதஸ்சாந்திம் ப்ரயஸ்ச்சமே!
    ஹிரண்ய கர்ப்ப கர்ப்பஸ்த்தம் ஹேமபீஜம் விபாவசோ: அநந்தபுண்ய பலதம் அதஸ்சாந்திம் ப்ரயஸ்ச்சமே. ஆவயோ: ஒளபாஸந விச்சேத ப்ரப்ருதி ஏதத் க்ஷண பர்யந்தம் ஒளபாஸந த்ரவ்ய ஸ்தாலீபாக த்ரவ்ய க்ருச்ர த்ரவ்ய ஆஜ்ய த்ரவ்ய ப்ரதிநிதி யத்க்கிஞ்சிது ஹிரண்யம் தண்டுலம் ஸ்ரீவைஷ்ணவாய ஸம்ப்ரததே! நம: நமமா அச்சுயுத: ப்ரீயதாம்!
  </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
  <mat-expansion-panel-header>04- ஒளபாஸன ஸங்கல்பம்
  </mat-expansion-panel-header><div class="div3">
    ப்ராணாநாயம்யா!
    ஸ்ரீ-ம்! ஆவயோ: பூர்வேத்யு: ஸாயம் ஒளபாஸநேந ஸஹ அத்ய ப்ராதரௌபாஸந ஹோமம் ஹோஷ்யாமி!
    <div class="svk">
      குறிப்பு:- நித்யப்படி இருவேளை ஔபாஸனம் செய்பவர்கள் - 
      நேற்றைய தின மாலைக்கான என்பதைக் குறிக்கும் - “பூர்வேத்யு: ஸாயம் ஔபாஸநேந 
      ஸஹ” - என்பதை விடுத்து, காலையில் - ப்ராதரௌபாஸந ஹோமம் ஹோஷ்யாமி என்றும் 
      மாலையில் - ஸாயம் ஔபாஸன ஹோமம் ஹோஷ்யாமி என்றும் ஸங்கல்பம் செய்துகொள்ளவேண்டும். 

    </div>

  </div>
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>05- ஔபாஸனம்
    </mat-expansion-panel-header><div class="div3">
      <div class="head2">பரிஷேசனம்</div>
      
    ஓம் அதிதே அநுமந்யஸ்வா
    ஓம் அநுமதே அநுமந்யஸ்வா
    ஓம் ஸரஸ்வதே அநுமந்யஸ்வா
    ஓம் தேவ ஸவித: ப்ரசுவா!
    <div class="head2">அக்னி த்யானம் - அர்ச்சனை</div>
    அஞ்சலீ க்ருத்வா!
சத்வாரி ச்ருங்கா த்ரய: அஸ்ய பாதா: த்வேசீர்ஷே ஸப்த ஹஸ்தாஸ: அஸ்யா த்ருதாபத்த: வ்ருஷப: ரோரவீதி மஹோதேவ: மர்த்யாநு ஆவிவேசா ஏஷஹிதேவ: ப்ரதிச: அநுஸர்வா: பூர்வோஹி ஜாத: ஸஉகர்பே அந்த்த: ஸவிஜாயமாந: ஸஜநிஷ்யமாண: ப்ரத்யங்முகா: திஷ்டதி விச்வதோமுக: ஹே அக்நே அபிமுகோ பவா!
அத: அக்நியர்ச்சநம்1
ஓம் அக்நயே நம: ஓம் ஜாதவேதஸே நம:
ஓம் ஸஹோஜஸே நம: ஓம் அஜிராப்ரபவே நம:
ஓம் வைஸ்வாநராய நம: ஓம் நர்யாபஸே நம:
ஓம் பங்க்திராதஸே நம: ஓம் விஸர்ப்பிணே நம:
ஓம் யஜ்ஞபுருஷாய நம:
ஸர்வேப்ய: ஸ்ரீ வைஷ்ணவேப்யோ நம:
<div class="head2">இருவேளை ஔபாஸனம்</div>
ஏகாம் ஸமிதம் ஆதாயா!
ஸ்வாஹா ஹோஷ்யாமி இதி அக்நிமித்வா!
பத்நீ ஹஸ்தௌ ப்ரோக்ஷ்யா
தண்டுலம் ப்ரதாயா!
புந: ப்ரோக்ஷ்யா!
த்விபாகம் க்ருத்வா. அர்தாம்சம் க்ருஹீத்வா. த்வேதா விபஜ்யா!
ஓம் அக்நயே ஸ்வாஹா
அக்நயே இதம் நமமா
ஓம் அக்நயே ஸ்விஷ்டக்ருதே ஸ்வாஹா
அக்நயே ஸ்விஷ்டக்ருத இதம் நமமா
ஏகாம் ஸமிதம் ஆதாயா
ஸ்வாஹா ஹோஷ்யாமி இதி அக்நிமித்வா!
புநர் அர்த்தாம்சம் க்ருஹீத்வா
த்வேதா விபஜ்யா
ஓம் சூர்யாய ஸ்வாஹா
சூர்யாய இதம் நமமா!
ஓம் அக்நயே ஸ்விஷ்டக்ருதே ஸ்வாஹா
அக்நயே ஸ்விஷ்டக்ருத இதம் நமமா
ப்ராணாநாயம்யா!
ஸ்ரீ - ம். ஆஹுதீ: ஸம்ஸர்க: ப்ராயஸ்ச்சித்தார்த்தம் வநஸ்பதி ஹோமம் கரிஷ்யே!
யத்;ரவேத்தா வநஸ்பதே தேவாநாம் குஹ்யா நாமாநி தத்ரஹவ்யாநி காமயா ஸ்வாஹா!
வநஸ்பதயே இதம் நமமா.
இதி தர்பௌ அக்நிமாதாயா!
<div class="head2">பரிஷேசனம்</div>
ஓம் அதிதே அந்வமக்குஸ்தா:
ஓம் அநுமதே அந்வமக்குஸ்தா:
ஓம் ஸரஸ்வதே அந்வமக்குஸ்தா:
ஓம் தேவஸவித: ப்ராசாவீ:
த்வே தர்பேண ஸ்ரீ விஷ்ணவே ஸ்வாஹா
ஸ்ரீ விஷ்ணவே பரமாத்மநே இதம் நமமா
    </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>06- உபஸ்தானம்
      </mat-expansion-panel-header><div class="div3">
        உத்திஷ்டத அக்நேநயா ஸுபதா ராயே அஸ்மாநு விஸ்வாநி தேவா வயுநாநி வித்வாநு யுயோதி அஸ்மது ஜுஹுராணம் ஏந: பூயிஷ்டாந்தே நமஉக்திம் விதேமா.
அக்நயே நம: மந்த்ரஹீனம் க்ரியாஹீனம் பக்திஹீனம் ஹுதாஸநா யத்துதந்து மயாதேவா பரிபூர்ணம் ததஸ்துதே ப்ராயஸ்ச்சித்தாநி அசேஷாணி தப: கர்ம ஆத்மகாநிவை யாநிதேஷாம் அசேஷாநாம் ஸ்ரீக்ருஷ்ணாநுஸ்மரணம் பரம்.
ப்ரணம்யா (ஸேவித்து)
அபிவாத்யா (அபிவாதி பண்ணி)
பவித்ரம் விஸ்ரஸ்யா (பவித்ரம் பிரித்துப் போட்டு)
ஆசம்யா (ஆசனம் இரு முறை பண்ணவேண்டும்). 
<div class="svk">
  வடகலை ஸ்ரீவைஷ்ணவர்கள் மட்டும் ஸாத்வீக த்யாகம் பண்ணவேண்டும். 
  “பகவாநேவ ஸ்வநியாம்ய ஸ்வரூபஸ்திதி ப்ரவ்ருத்தி ஸ்வசேஷதா
  ஏகரஸேந அநேந ஆத்மநா கர்த்ரா ஸ்வகீயைஸ்ச உபகரணை: 
  ஸ்வாராதனைக ப்ரயோசனாய பரமபுருஷ: ஸர்வசேஷி ஸர்வேஸ்வர: 
  ஸ்ரீய:பதி: ஸ்வசேஷபூதமிதம் ஔபாஸனாக்யம் கர்ம ஸ்வஸ்மை 
  ஸ்வப்ரீதயே பகவாந் ஸ்வயமேவ காரிதவான். 
  ஸர்வம் ஸ்ரீ க்ருஷ்ணார்பணமஸ்து. 
</div>
மற்றவர்கள் - காயேந வாசா மநஸே இந்த்ரியைர்வா 
புத்யா ஆத்மநாவா ப்ரஹ்ருதே ஸ்வபாவாத் கரோமி 
யத்யத் ஸகலம் பரஸ்மை ஸ்ரீமந் நாராயணாயேதி ஸமர்ப்பயாமி. 
ஸர்வம் ஸ்ரீ க்ருஷ்ணார்பணமஸ்து. 
      </div>
      </mat-expansion-panel>
</mat-accordion>`;

const AupaasanamPage = () => {
  return (
    <div className="vaideekam-page-container w-full max-w-4xl mx-auto p-4 md:p-6 pb-24">
      <SEO title="ஔபாஸனம் - Ahobilam" />
      <div 
        className="vaideekam-content bg-white p-6 rounded-xl shadow-sm border border-green-100/50"
        dangerouslySetInnerHTML={{ __html: HTML_CONTENT }} 
      />
    </div>
  );
};

export default AupaasanamPage;
